import { videoProductionVariantEndpoint } from "@/config/endpoints";
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

export default function useCurrentVariant(
  variantId: number | null | undefined | string
) {
  const query = useQuery({
    queryKey: ["video-production", "variant", variantId],
    queryFn: async () => {
      if (!variantId) return null;
      const res = await axiosInstance.get(
        `${videoProductionVariantEndpoint}/${variantId}`
      );
      return res.data?.variant ?? res.data ?? null;
    },
  });

  return {
    variant: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
